<template>
  <div class="container" v-show="modalIsOpen">
    <div class="overlay"></div>
    <div class="modalContainer">
      <div class="box modal">
        <h2 class="title">{{ modalTitle }}</h2>
        <slot></slot>
        <div class="buttonContainer">
          <button class="button close" @click="$emit('on-close')">
            <!-- {{ $t("modal.close") }} -->
            {{ buttonText || $t("modal.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/variables.scss";
@import "@/mixins.scss";

.container {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: grey;
    opacity: 0.5;
  }

  .modalContainer {
    position: relative;
    @include max-width-container;
    display: flex;
    height: 100%;
    .modal {
      max-height: 85%;
      margin: auto;
      padding: 25px 30px;
      overflow: hidden;

      display: flex;
      flex-direction: column;

      .title {
        margin-top: 0;
        margin-bottom: 1.5rem;
        flex-shrink: 0;
      }

      .content {
        overflow: auto;
      }

      .buttonContainer {
        text-align: center;
        flex-shrink: 0;

        .close {
          margin: 0;
          margin-top: 25px;
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: "Modal",

  props: {
    modalIsOpen: {
      type: Boolean,
      required: true
    },
    modalTitle: {
      type: String,
      required: false
    },
    buttonText: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      name: "",
      email: "",
      message: "",
      hasSent: false,
      showError: false
    };
  }
};
</script>
